import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import { ScenesCreationProgress } from 'types/ScenesCreationProgress';
import { Scene } from 'types/Scene';

const defaultState: ScenesCreationProgress = {};

export const setSceneCreationProgress = createActionCreator(
  'CREATION_PROGRESS/SET',
  resolve => (progress: number, sceneId: string) => resolve({ progress, sceneId })
);

export const scenesCreationProgress = createReducer(defaultState, handle => [
  handle(setSceneCreationProgress, (store, { payload }) => ({
    ...store,
    [payload.sceneId]: payload.progress
  }))
]);

export const getSceneCreationProgress = (id: Scene['id']) => (
  state: AppState
): number | undefined => state.scenesCreationProgress[id];

export const getScenesCreationProgress = (state: AppState): ScenesCreationProgress =>
  state.scenesCreationProgress;

export const getCreationProgressOfScene = (scene: Scene) => (state: AppState): number =>
  scene.uploaded || (!scene.uploaded && !scene.src) || scene.uploaded === undefined
    ? state.scenesCreationProgress[scene.id]
    : null;
